module.exports = __webpack_public_path__ + "img/martinique.37de241e.png";